import { Component } from '@angular/core';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-accessibility-page',
  standalone: true,
  imports: [
    ToggleSwitchModule,
    FormsModule,
  ],
  templateUrl: './accessibility-page.component.html',
  styleUrl: './accessibility-page.component.scss'
})
export class AccessibilityPageComponent {

  protected darkMode: boolean;

  changeDarkMode () {
    console.log(this.darkMode);
  }

}
